var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('file-pond',{ref:_vm.uniqueId,attrs:{"name":_vm.label,"label-idle":_vm.label,"allow-multiple":false,"accepted-file-types":"video/*"},on:{"init":_vm.handleFilePondInit,"addfile":_vm.oninitfileHandler,"removefile":_vm.onremovefile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }